import { render } from "./SassApple.vue?vue&type=template&id=bdd6b930&lang=true"
import script from "./SassApple.vue?vue&type=script&lang=js"
export * from "./SassApple.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__